import { useState, useEffect } from 'react';
import {
  Container,
  Stack,
  Typography,
  Card,
  Button,
  CircularProgress,
  Backdrop
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { EditorState, convertFromHTML, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { stateToHTML } from 'draft-js-export-html';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  setAboutPageContent,
  getAboutPageContent,
  getAboutPagePhoto,
  setAboutPagePhoto
} from '../utils/requests/aboutRequest';
import UploadPreview from '../components/uploads/UploadPreview';

export default function AboutPage() {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [photo, setPhoto] = useState();
  const [file, setFile] = useState();
  const [isSending, setIsSending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => getData(), []);

  function getData() {
    setIsLoading(true);
    getAboutPageContent().then((content) => {
      const blocksFromHTML = convertFromHTML(content);
      const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(state));
      setIsLoading(false);
    });

    getAboutPagePhoto().then((photo) => {
      setPhoto(photo);
    });
  }

  function onFileChange(e) {
    setFile(e.target.files[0]);
  }

  function save() {
    setIsSending(true);
    const html = stateToHTML(editorState.getCurrentContent());
    setAboutPageContent(html).then((response) => {
      toast.success(response.data.message);
      // setIsSending(false);
    });
    if (file) {
      setAboutPagePhoto(file)
        .then((response) => {
          setIsSending(false);
          toast.success(response.data.message);
        })
        .catch((error) => {
          if (error.response) {
            const { data } = error.response;
            if (data.data.file) {
              toast.error(data.data.file[0]);
            }
          }
        });
    }
  }

  return (
    <Container>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Typography variant="h4" sx={{ mb: 5 }}>
        Edit About Page
      </Typography>
      <Stack spacing={3}>
        <UploadPreview currentPhoto={photo} onChange={(e) => onFileChange(e)} />
        <Card className="editor" style={{ minHeight: 250 }} sx={{ p: 1 }}>
          <Editor
            editorState={editorState}
            onEditorStateChange={(e) => setEditorState(e)}
            toolbar={{
              inline: { inDropdown: true },
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: true },
              image: { inDropdown: false }
            }}
          />
        </Card>
      </Stack>
      <Stack sx={{ mt: 5, ml: 1 }} direction="row">
        <LoadingButton loading={isSending} variant="contained" onClick={(e) => save(e)}>
          Save
        </LoadingButton>
        <Button onClick={() => navigate('/')}>Cancel</Button>
      </Stack>
    </Container>
  );
}
